import { render, staticRenderFns } from "./AnswerParser.vue?vue&type=template&id=3b920f20&scoped=true&"
import script from "./AnswerParser.vue?vue&type=script&lang=js&"
export * from "./AnswerParser.vue?vue&type=script&lang=js&"
import style0 from "./AnswerParser.vue?vue&type=style&index=0&id=3b920f20&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b920f20",
  null
  
)

export default component.exports